<template>
  <div class="popup-wrap bank-verify-wrap" :class="{ active: visible }">
    <div class="popup-box verify-code-popup-box">
      <a class="popup-close" href="javascript:;" @click.prevent="handleClose"><i class="fa-solid fa-xmark" /></a>
      <div class="form-popup popup-padding">
        <div class="title-block">
          <h4 class="verify-popup-title">
            {{ $t(`Bao.user_verify_code_title_${mode}`) }}
          </h4>
          <hr class="title-hr">
        </div>

        <p class="verify-desc">
          {{ $t(`Bao.user_verify_code_desc_${mode}`) }}
        </p>

        <div class="verify-input-wrap">
          <input
            v-model="validateCode"
            class="for-input inpType"
            :class="{ 'isInvalid': errors.has('verify_code') }"
            type="text"
            autocomplete="off"
            :placeholder="$t('Bao.user_verify_code_notice')"
          >
          <div v-if="errors.has('verify_code')" class="input-feedback text-align-R">
            {{ errors.first('verify_code') }}
          </div>
        </div>

        <div class="info-row">
          <span class="icon-alert-dot">!</span>
          <span class="info-text">{{ $t(`Bao.user_verify_code_info_1_${mode}`) }}</span>
        </div>

        <b class="color-primary verify-note-bold">
          {{ $t('Bao.user_verify_code_info_2') }}
        </b>
        <p class="verify-note-light">
          {{ $t('Bao.user_verify_code_info_3') }}
        </p>

        <div class="authen-btn-wrap">
          <button class="btn-primary resend-btn" :disabled="timerCount" @click.prevent="sendCode">
            <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.user_verify_code_resend') }}</span>
          </button>
          <button class="btn-primary verify-submit-btn" :disabled="!validateCode" @click.prevent="handleConfirm">
            <span>{{ $t("Bao.submit") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerifyCode } from '@/api/user'
import { showNotice, setErrorMessage } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  name: 'BankVerifyCode',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validateCode: '',
      timerCount: true,
      limitSecond: 60
    }
  },
  computed: {
    ...mapGetters(['memberInfo', 'permissionInfo']),
    email_need_verify() {
      return this.permissionInfo.email_need_verify
    },
    mode() {
      // 是開啟信箱驗證,還是手機驗證
      return this.email_need_verify ? 'email' : 'phone'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.validateCode = ''
        this.errors.clear()
        this.sendCode()
      }
    }
  },
  created() {
    import('@/assets/css/verify-code-popup.css')
  },
  methods: {
    sendCode() {
      getVerifyCode({ username: this.memberInfo.username, verify_type: 'memberBank', media: this.mode })
        .then(response => {
          const { code, message } = response.data.data
          if (code) {
            const i18nKey = 'Bao.user_verify_code_res_' + code
            showNotice(this.$te(i18nKey) ? this.$t(i18nKey) : message)
          }

          this.limitSecond = 60
          this.timerCount = true
          this.countDown()
        })
        .catch(error => {
          showNotice(error.response.data.msg)
          this.handleClose()
        })
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 60
          clearInterval(timer)
        }
      }, 1000)
    },
    handleConfirm() {
      if (!this.validateCode) return
      this.$emit('confirm', this.validateCode)
    },
    handleClose() {
      this.$emit('close')
    },
    setServerError(response) {
      setErrorMessage(response, this.errors)
    }
  }
}
</script>
